/**
 * Дизайн-кит бренд-экранов Lovirds (онбординг-анкета, вход, заставка).
 * Чистый React + framer-motion + свой CSS (auth.css), иконки — инлайн SVG.
 */
import { forwardRef, useId, useState } from 'react';
import { motion } from 'framer-motion';
import { NAME_PROJECT } from '../../utils';
import './auth.css';


// ============================== ИКОНКИ ==============================
const makeIcon = (paths) => function Icon(props) {
    return (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor"
             strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
            {paths}
        </svg>
    );
};

export const IconBack = makeIcon(<path d="M15 18l-6-6 6-6" />);
export const IconCheck = makeIcon(<path d="M20 6L9 17l-5-5" />);
export const IconPlus = makeIcon(<path d="M12 5v14M5 12h14" />);
export const IconMinus = makeIcon(<path d="M5 12h14" />);
export const IconMail = makeIcon(<><rect x="3" y="5" width="18" height="14" rx="3" /><path d="M3 7l9 6 9-6" /></>);
export const IconLock = makeIcon(<><rect x="4" y="11" width="16" height="10" rx="3" /><path d="M8 11V7a4 4 0 018 0v4" /></>);
export const IconPhone = makeIcon(<><rect x="6" y="2" width="12" height="20" rx="3" /><path d="M11 18h2" /></>);
export const IconPin = makeIcon(<><path d="M12 21s-7-6.2-7-11.5A7 7 0 0112 2.5a7 7 0 017 7C19 14.8 12 21 12 21z" /><circle cx="12" cy="9.5" r="2.5" /></>);
export const IconSearch = makeIcon(<><circle cx="11" cy="11" r="7" /><path d="M20 20l-3.5-3.5" /></>);
export const IconEye = makeIcon(<><path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12z" /><circle cx="12" cy="12" r="3" /></>);
export const IconClose = makeIcon(<path d="M6 6l12 12M18 6L6 18" />);
export const IconEyeOff = makeIcon(<><path d="M17.9 17.9A10.5 10.5 0 0112 19c-6.4 0-10-7-10-7a18.4 18.4 0 015.1-5.9M9.9 4.2A9.6 9.6 0 0112 4c6.4 0 10 7 10 7a18.5 18.5 0 01-2.2 3.2" /><path d="M1 1l22 22" /></>);
// Кабинеты: бизнес, партнёр, админ
export const IconMegaphone = makeIcon(<><path d="M3 11v2a1 1 0 001 1h2l4 4V6L6 10H4a1 1 0 00-1 1z" /><path d="M14 8.5a4 4 0 010 7" /><path d="M17 6a8 8 0 010 12" /></>);
export const IconHandshake = makeIcon(<><path d="M12 7l2-2a2.8 2.8 0 014 0l3 3-5 5" /><path d="M12 7l-2-2a2.8 2.8 0 00-4 0L3 8l5 5" /><path d="M8 13l3 3 2-2 3 3" /></>);
export const IconShield = makeIcon(<><path d="M12 3l7 3v5c0 4.6-3 8.2-7 10-4-1.8-7-5.4-7-10V6l7-3z" /><path d="M9 12l2 2 4-4" /></>);
// Состояния экранов-сообщений — вместо эмодзи
export const IconAlert = makeIcon(<><path d="M12 4l9 16H3l9-16z" /><path d="M12 10v4M12 17.5h.01" /></>);
export const IconMailSent = makeIcon(<><rect x="3" y="5" width="18" height="14" rx="3" /><path d="M3 7l9 6 9-6" /><path d="M8 21l3-3 3 3" /></>);
export const IconLinkOff = makeIcon(<><path d="M9 15l-2 2a3.5 3.5 0 01-5-5l2-2" /><path d="M15 9l2-2a3.5 3.5 0 015 5l-2 2" /><path d="M3 3l18 18" /></>);
export const IconLockCheck = makeIcon(<><rect x="4" y="11" width="16" height="10" rx="3" /><path d="M8 11V7a4 4 0 018 0v4" /><path d="M9.5 16l1.8 1.8L15 14" /></>);
export const IconBan = makeIcon(<><circle cx="12" cy="12" r="9" /><path d="M6 6l12 12" /></>);
export const IconCheckCircle = makeIcon(<><circle cx="12" cy="12" r="9" /><path d="M8 12.5l2.6 2.6L16 9.5" /></>);
export const IconClock = makeIcon(<><circle cx="12" cy="12" r="9" /><path d="M12 7v5.5l3.5 2" /></>);
export const IconPlug = makeIcon(<><path d="M9 3v6M15 3v6" /><path d="M6 9h12v3a6 6 0 01-6 6 6 6 0 01-6-6V9z" /><path d="M12 18v3" /></>);
export const IconCamera = makeIcon(<><path d="M4 8h3l1.6-2.4A1 1 0 019.5 5h5a1 1 0 01.9.6L17 8h3a1 1 0 011 1v9a1 1 0 01-1 1H4a1 1 0 01-1-1V9a1 1 0 011-1z" /><circle cx="12" cy="13" r="3.6" /></>);
export const IconHeart = makeIcon(<path d="M12 20s-7-4.4-7-9.5A4.5 4.5 0 0112 8a4.5 4.5 0 017 2.5C19 15.6 12 20 12 20z" fill="currentColor" stroke="none" />);


// ============================== ИКОНКИ АНКЕТЫ ==============================
// Свой набор вместо эмодзи: эмодзи рисуются шрифтом системы и выглядят
// по-разному на iPhone, Android и в Windows — фирменного вида с ними не будет.
const choiceIcon = (paths) => function ChoiceGlyph(props) {
    return (
        <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="2.4"
             strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
            {paths}
        </svg>
    );
};

// Мужчина / женщина — классические знаки: читаются без подписи в любой стране
const GlyphMan = choiceIcon(<><circle cx="20" cy="28" r="10" /><path d="M29 19l10-10M31 9h8v8" /></>);
const GlyphWoman = choiceIcon(<><circle cx="24" cy="19" r="10" /><path d="M24 29v12M18 36h12" /></>);

// Пара — два кольца и сердце между ними
const GlyphCouple = choiceIcon(<>
    <circle cx="17" cy="26" r="9" /><circle cx="31" cy="26" r="9" />
    <path d="M24 12.5c1.8-2.6 6-1.7 6 1.6 0 2.6-3.4 4.7-6 6.4-2.6-1.7-6-3.8-6-6.4 0-3.3 4.2-4.2 6-1.6z" />
</>);
const GlyphCoupleMW = choiceIcon(<>
    <circle cx="16" cy="30" r="8" /><path d="M23 23l7-7M23 16h7v7" />
    <circle cx="36" cy="18" r="7" /><path d="M36 25v9M31 30h10" />
</>);
const GlyphCoupleWW = choiceIcon(<>
    <circle cx="15" cy="18" r="7" /><path d="M15 25v9M10 30h10" />
    <circle cx="33" cy="18" r="7" /><path d="M33 25v9M28 30h10" />
</>);
const GlyphCoupleMM = choiceIcon(<>
    <circle cx="14" cy="30" r="8" /><path d="M21 23l7-7M21 16h7v7" />
    <circle cx="30" cy="34" r="8" /><path d="M37 27l7-7M37 20h7v7" />
</>);

// Цели знакомства
const GlyphRings = choiceIcon(<>
    <circle cx="19" cy="30" r="10" /><circle cx="31" cy="24" r="10" />
    <path d="M31 8l3 5h-6l3-5z" />
</>);
const GlyphChat = choiceIcon(<>
    <path d="M8 14a4 4 0 014-4h16a4 4 0 014 4v9a4 4 0 01-4 4H18l-7 6v-6a3 3 0 01-3-3v-10z" />
    <path d="M36 18h2a4 4 0 014 4v9a3 3 0 01-3 3v6l-6-5" />
</>);
const GlyphFun = choiceIcon(<>
    <path d="M14 10h20l-8 11v13" /><path d="M19 38h14" />
    <path d="M38 12l1.6 3.4L43 17l-3.4 1.6L38 22l-1.6-3.4L33 17l3.4-1.6L38 12z" />
</>);

/** Уровень дохода: шесть столбиков, закрашено ровно столько, сколько выбрано. */
function GlyphLevel({ level = 1, ...props }) {
    const bars = [0, 1, 2, 3, 4, 5];
    return (
        <svg viewBox="0 0 48 48" fill="none" aria-hidden="true" {...props}>
            {bars.map((i) => {
                const h = 8 + i * 5.6;
                return (
                    <rect key={i} x={5 + i * 7} y={40 - h} width="4.6" height={h} rx="2.3"
                          fill={i <= level ? 'currentColor' : 'none'}
                          stroke="currentColor" strokeWidth="2" opacity={i <= level ? 1 : 0.38} />
                );
            })}
        </svg>
    );
}

const CHOICE_ICONS = {
    man: GlyphMan,
    woman: GlyphWoman,
    couple: GlyphCouple,
    'couple-mw': GlyphCoupleMW,
    'couple-ww': GlyphCoupleWW,
    'couple-mm': GlyphCoupleMM,
    rings: GlyphRings,
    chat: GlyphChat,
    fun: GlyphFun,
};

/** Иконка варианта ответа по имени из конфига анкеты. */
export function ChoiceIcon({ name, level, className = 'lv-choice__icon' }) {
    if (typeof level === 'number') return <GlyphLevel level={level} className={className} />;
    const Glyph = CHOICE_ICONS[name];
    return Glyph ? <Glyph className={className} /> : null;
}


// ============================== ФОН ==============================
// Позиции сердечек фиксированы (без Math.random) — одинаковая картинка при каждом рендере.
const HEARTS = Array.from({ length: 14 }, (_, i) => ({
    left: `${(i * 37 + 7) % 100}%`,
    size: 12 + ((i * 7) % 18),
    duration: 11 + ((i * 5) % 9),
    delay: -((i * 1.7) % 14),
    glyph: i % 3 === 0 ? '♡' : '♥',
}));

/**
 * variant="love" — знакомства (сердечки, розово-фиолетовый).
 * variant="pro"  — рабочие кабинеты: холоднее градиент и сетка вместо сердечек
 *                  (стили — в cabinet.css).
 */
export function AuthBackground({ children, variant = 'love' }) {
    const pro = variant === 'pro';
    return (
        <div className={`lv-auth${pro ? ' lv-auth--pro' : ''}`}>
            <div className="lv-bg" aria-hidden="true">
                <span className="lv-blob lv-blob--1" />
                <span className="lv-blob lv-blob--2" />
                <span className="lv-blob lv-blob--3" />
                {pro ? null : HEARTS.map((h, i) => (
                    <span key={i} className="lv-heart" style={{
                        left: h.left, fontSize: h.size,
                        animationDuration: `${h.duration}s`, animationDelay: `${h.delay}s`,
                    }}>{h.glyph}</span>
                ))}
            </div>
            {children}
        </div>
    );
}


// ============================== БРЕНД ==============================
export function Logo({ size = 'md' }) {
    return (
        <div className={`lv-logo${size === 'lg' ? ' lv-logo--lg' : ''}`}>
            <img src="/logo.png" alt={NAME_PROJECT} />
        </div>
    );
}

/**
 * Название бренда — картинкой из логотипа: шрифт названия фирменный (товарный знак),
 * системным его не повторить. Файл: public/logo-wordmark.png (прозрачный фон, белое).
 * Если файла ещё нет — рисуем текстом, чтобы экран не ломался.
 */
export function Wordmark({ size = 'md' }) {
    const [failed, setFailed] = useState(false);
    const mod = size === 'md' ? '' : ` lv-wordmark--${size}`;
    if (failed) return <div className={`lv-wordmark__text${mod}`}>{NAME_PROJECT}</div>;
    return (
        <img className={`lv-wordmark${mod}`} src="/logo-wordmark.png" alt={NAME_PROJECT}
             onError={() => setFailed(true)} />
    );
}

export function Hero() {
    return (
        <motion.div className="lv-hero"
                    initial={{ opacity: 0, y: -8 }} animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.4 }}>
            <Logo />
            <Wordmark />
            <div className="lv-hero__tag">Знакомства для искренних отношений</div>
        </motion.div>
    );
}

/** Заставка на время проверки входа — вместо белого «Идет верификация...». */
export function BrandSplash() {
    return (
        <AuthBackground>
            <div className="lv-splash"><Logo size="lg" /></div>
        </AuthBackground>
    );
}


// ============================== КНОПКИ ==============================
export function PrimaryButton({ children, loading = false, disabled = false, variant = 'solid', className = '', ...rest }) {
    const ghost = variant === 'ghost';
    const inactive = disabled || loading;
    return (
        <motion.button type="button" {...rest}
                       className={`lv-btn${ghost ? ' lv-btn--ghost' : ''}${className ? ` ${className}` : ''}`}
                       disabled={inactive}
                       whileTap={inactive ? undefined : { scale: 0.97 }}>
            {loading ? <span className="lv-spinner" aria-hidden="true" /> : null}
            {ghost ? children : <span className="lv-btn__text">{children}</span>}
        </motion.button>
    );
}

export function TextLink({ children, small = false, className = '', ...rest }) {
    return (
        <button type="button" {...rest}
                className={`lv-link${small ? ' lv-link--sm' : ''}${className ? ` ${className}` : ''}`}>
            {children}
        </button>
    );
}

export function Spinner({ size = 'md' }) {
    return <span className={`lv-spinner${size === 'lg' ? ' lv-spinner--lg' : ''}`} aria-label="Загрузка" />;
}

export function IconButton({ label, children, ...rest }) {
    return (
        <motion.button type="button" className="lv-iconbtn" aria-label={label}
                       whileTap={{ scale: 0.92 }} {...rest}>
            {children}
        </motion.button>
    );
}


// ============================== ПОЛЯ ==============================
export const Field = forwardRef(function Field(
    { label, icon, error, end, size, className = '', id, ...inputProps }, ref,
) {
    const autoId = useId();
    const inputId = id || autoId;
    return (
        <div className={`lv-field${size === 'xl' ? ' lv-field--xl' : ''}${error ? ' has-error' : ''}${className ? ` ${className}` : ''}`}>
            {label ? <label className="lv-field__label" htmlFor={inputId}>{label}</label> : null}
            <div className="lv-field__control">
                {icon ? <span className="lv-field__icon">{icon}</span> : null}
                <input ref={ref} id={inputId} aria-invalid={Boolean(error)} {...inputProps} />
                {end}
            </div>
            {error ? (
                <motion.div className="lv-field__error" role="alert"
                            initial={{ opacity: 0, y: -4 }} animate={{ opacity: 1, y: 0 }}>
                    {error}
                </motion.div>
            ) : null}
        </div>
    );
});

export function PasswordToggle({ shown, onToggle }) {
    return (
        <button type="button" className="lv-field__end" onClick={onToggle}
                aria-label={shown ? 'Скрыть пароль' : 'Показать пароль'}>
            {shown ? <IconEyeOff /> : <IconEye />}
        </button>
    );
}

export function RangeCard({ label, value, min, max, step = 1, unit, empty = false, onChange }) {
    const p = ((value - min) / (max - min)) * 100;
    return (
        <div className="lv-range-card">
            <div className="lv-range-card__head">
                <span className="lv-range-card__label">{label}</span>
                <span className={`lv-range-card__value${empty ? ' is-empty' : ''}`}>
                    {value}<small>{unit}</small>
                </span>
            </div>
            <input type="range" className="lv-range" min={min} max={max} step={step} value={value}
                   style={{ '--p': `${p}%` }} aria-label={label}
                   onChange={(e) => onChange(Number(e.target.value))} />
        </div>
    );
}

export function Checkbox({ checked, onChange, children }) {
    return (
        <button type="button" role="checkbox" aria-checked={checked}
                className={`lv-check${checked ? ' is-checked' : ''}`}
                onClick={() => onChange(!checked)}>
            <span className="lv-check__box"><IconCheck width={15} height={15} strokeWidth={3.2} /></span>
            <span>{children}</span>
        </button>
    );
}


// ============================== ВЫБОР ==============================
function ChoiceCard({ option, index, row, selected, onSelect }) {
    return (
        <motion.button type="button" role="radio" aria-checked={selected}
                       className={`lv-choice${row ? ' lv-choice--row' : ''}${selected ? ' is-selected' : ''}`}
                       onClick={onSelect}
                       initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }}
                       transition={{ delay: 0.12 + index * 0.06, type: 'spring', stiffness: 380, damping: 30 }}
                       whileTap={{ scale: 0.96 }}>
            {option.badge && !row ? <span className="lv-choice__badge">{option.badge}</span> : null}
            <ChoiceIcon name={option.icon} level={option.level} />
            <span className="lv-choice__text">
                <span className="lv-choice__label">{option.label}</span>
                {option.hint ? <span className="lv-choice__hint">{option.hint}</span> : null}
            </span>
            {option.badge && row ? <span className="lv-choice__badge lv-choice__badge--inline">{option.badge}</span> : null}
            {row
                ? <span className="lv-radio"><IconCheck width={15} height={15} strokeWidth={3.2} /></span>
                : <span className="lv-choice__check"><IconCheck width={15} height={15} strokeWidth={3.2} /></span>}
        </motion.button>
    );
}

/** Карточки выбора: layout="grid" — плитки 2 в ряд, layout="list" — строки. */
export function ChoiceGroup({ options, value, onChange, layout = 'grid' }) {
    const row = layout === 'list';
    return (
        <div className={row ? 'lv-list' : 'lv-grid'} role="radiogroup">
            {options.map((o, i) => (
                <ChoiceCard key={String(o.value)} option={o} index={i} row={row}
                            selected={value === o.value} onSelect={() => onChange(o.value)} />
            ))}
        </div>
    );
}

export function Chip({ selected = false, children, className = '', ...rest }) {
    return (
        <motion.button type="button" aria-pressed={selected} {...rest}
                       className={`lv-chip${selected ? ' is-selected' : ''}${className ? ` ${className}` : ''}`}
                       whileTap={{ scale: 0.94 }}>
            {selected ? <IconCheck width={15} height={15} strokeWidth={3} /> : null}
            {children}
        </motion.button>
    );
}


// ============================== ПРОГРЕСС, СООБЩЕНИЯ ==============================
export function ProgressBar({ value }) {
    const pct = Math.max(0, Math.min(1, value)) * 100;
    return (
        <div className="lv-progress" role="progressbar" aria-valuemin={0} aria-valuemax={100}
             aria-valuenow={Math.round(pct)}>
            <motion.div className="lv-progress__fill" initial={false} animate={{ width: `${pct}%` }}
                        transition={{ type: 'spring', stiffness: 120, damping: 20 }} />
        </div>
    );
}

export function Notice({ tone = 'info', children }) {
    const error = tone === 'error';
    return (
        <motion.div className={`lv-notice${error ? ' lv-notice--error' : ''}`} role={error ? 'alert' : 'status'}
                    initial={{ opacity: 0, y: -6 }} animate={{ opacity: 1, y: 0 }}>
            <span className="lv-notice__icon" aria-hidden="true">
                {error ? <IconAlert width={18} height={18} /> : <IconMailSent width={18} height={18} />}
            </span>
            <span>{children}</span>
        </motion.div>
    );
}


/**
 * Экран-сообщение: подтверждение email, истёкшая ссылка, блокировка и т.п.
 * icon — иконка из набора выше (раньше сюда передавали эмодзи, но они
 * на каждой системе рисуются по-своему и выбивались из оформления).
 */
export function StatusScreen({ icon, title, text, children }) {
    return (
        <AuthBackground>
            <div className="lv-screen lv-status">
                <motion.div className="lv-status__card"
                            initial={{ opacity: 0, y: 20, scale: 0.97 }} animate={{ opacity: 1, y: 0, scale: 1 }}
                            transition={{ type: 'spring', stiffness: 260, damping: 26 }}>
                    {icon ? <div className="lv-status__icon" aria-hidden="true">{icon}</div> : null}
                    <h1 className="lv-status__title">{title}</h1>
                    {text ? <p className="lv-status__text">{text}</p> : null}
                    {children ? <div className="lv-status__actions">{children}</div> : null}
                </motion.div>
            </div>
        </AuthBackground>
    );
}


// ============================== УСПЕХ ==============================
const BURST = Array.from({ length: 18 }, (_, i) => {
    const angle = (i / 18) * Math.PI * 2;
    const dist = 140 + (i % 4) * 32;
    return {
        '--x': `${Math.round(Math.cos(angle) * dist)}px`,
        '--y': `${Math.round(Math.sin(angle) * dist)}px`,
        '--r': `${(i % 2 ? 1 : -1) * (20 + i * 7)}deg`,
        '--s': `${22 + (i % 3) * 8}px`,
        '--d': `${(i % 5) * 0.04}s`,
    };
});

export function SuccessBurst({ title, subtitle }) {
    return (
        <motion.div className="lv-success" role="status" initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
            <div className="lv-burst" aria-hidden="true">
                {BURST.map((vars, i) => (
                    <i key={i} style={vars}><IconHeart width="100%" height="100%" /></i>
                ))}
            </div>
            <div className="lv-success__inner">
                <div className="lv-success__heart" aria-hidden="true"><IconHeart width={92} height={92} /></div>
                <div className="lv-success__title">{title}</div>
                {subtitle ? <div className="lv-success__sub">{subtitle}</div> : null}
            </div>
        </motion.div>
    );
}
